import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import indexedDBStorage from 'redux-persist-indexeddb-storage'
import sessionStorage from 'redux-persist/lib/storage/session';
import accountRequestReducer from './reducers/accountRequestSlice.js';
import alertReducer from './reducers/alertSlice.js';
import appReducer from './reducers/appSlice.js';
import authReducer from './reducers/authSlice.js';
import beaconReducer from './reducers/beaconSlice.js';
import blobReducer from './common/reducers/blobSlice.js';
import clientConfigReducer from './reducers/clientConfigSlice.js';
import contactReducer from './reducers/contactSlice.js';
import crewFilterReducer from './reducers/crewFilterSlice.js';
import crewFormReducer from './reducers/crewCustomFormSlice.js';
import crewMemberReducer from './reducers/crewMemberSlice.js';
import crewNoteReducer from './reducers/crewNoteSlice.js';
import crewResourceReducer from './reducers/crewResourceSlice.js';
import crewReducer from './reducers/crewSlice.js';
import crewStatusReducer from './reducers/crewStatusSlice.js';
import decisionReducer from './reducers/decisionSlice.js';
import docTypeReducer from './reducers/docTypeSlice.js';
import entityReducer from './common/reducers/entitySlice.js';
import eventReducer from './reducers/eventSlice.js';
import geoFencingReducer from './reducers/geoFencingSlice.js';
import glossaryReducer from './reducers/glossarySlice.js';
import jobAssistanceReducer from './reducers/jobAssistanceSlice.js';
import requestableJobsReducer from './reducers/requestableJobsSlice.js';
import jobAccessRequestsReducer from './reducers/jobAccessRequestsSlice.js';
import jobFormReducer from './reducers/jobCustomFormSlice.js';
import jobFilterReducer from './reducers/jobFilterSlice.js';
import jobImageReducer from './reducers/jobImageSlice.js';
import jobNoteReducer from './reducers/jobNoteSlice.js';
import jobProcedureReducer from './reducers/jobProcedureSlice.js';
import jobRelatedDocReducer from './reducers/jobRelatedDocSlice.js'
import jobRelationReducer from './reducers/jobRelationSlice.js';
import jobReducer from './reducers/jobSlice.js';
import jobStatusReducer from './reducers/jobStatusSlice';
import jobTagReducer from './reducers/jobTagSlice.js';
import jobUpdateReducer from './reducers/jobUpdateSlice.js';
import levelReducer from './reducers/levelSlice.js';
import listReducer from './reducers/listSlice.js';
import listNotesReducer from './reducers/listNotesSlice.js';
import locationReducer from './reducers/locationSlice.js';
import logReducer from './reducers/logSlice.js';
import mapOverlayReducer from './reducers/mapOverlaySlice.js';
import mapPathReducer from './reducers/mapPathSlice.js';
import mapViewReducer from './reducers/mapViewSlice.js';
import mapZoneReducer from './reducers/mapZoneSlice.js';
import messageHistoryReducer from './reducers/messageHistorySlice.js';
import notificationRuleReducer from './reducers/notificationRuleSlice.js';
import outsideAgencyReducer from './reducers/outsideAgencySlice.js';
import participantReducer from './reducers/participantSlice.js';
import pendingUpdateReducer from './common/reducers/pendingUpdateSlice.js';
import priorityReducer from './reducers/prioritySlice.js';
import problemReducer from './reducers/problemSlice.js';
import procedureReducer from './reducers/procedureSlice.js';
import publicFormReducer from './reducers/publicFormSlice.js';
import publicGroupReducer from './reducers/publicGroupSlice.js';
import refDocReducer from './reducers/refDocSlice.js';
import requiredCommentsReducer from './reducers/requiredCommentSlice.js';
import resultReducer from './reducers/resultSlice.js';
import scheduledJobReducer from './reducers/scheduledJobSlice.js';
import settingReducer from './reducers/settingSlice.js';
import siteReducer from './reducers/siteSlice.js';
import sitrepReducer from './reducers/sitrepSlice.js';
import sitrepDefReducer from './reducers/sitrepDefSlice.js';
import stdReplyReducer from './reducers/stdReplySlice.js';
import taskListReducer from './reducers/taskListSlice.js';
import taskListEntryReducer from './reducers/taskListEntrySlice.js';
import taskListNoteReducer from './reducers/taskListNoteSlice.js';
import typeReducer from './reducers/typeSlice.js';
import weatherReducer from './reducers/weatherSlice.js';
import epcrReducer from './reducers/epcrSlice.js';
import epcrHistoryReducer from './reducers/epcrHistorySlice.js';
import epcrMedicationsReducer from './reducers/epcrMedicationSlice.js';
import epcrAllergiesReducer from './reducers/epcrAllergySlice.js';
import epcrComplaintReducer from './reducers/epcrComplaintSlice.js';
import epcrDispositionReducer from './reducers/epcrDispositionSlice.js';
import epcrNotesReducer from './reducers/epcrNotesSlice.js';
import epcrVitalReducer from './reducers/epcrVitalSlice.js';
import epcrTreatmentMedicationReducer from './reducers/epcrTreatmentMedicationSlice.js';
import epcrProcedureReducer from './reducers/epcrProcedureSlice.js';
import userReducer from './reducers/userSlice';

const reducer = {};
reducer[accountRequestReducer.name] = accountRequestReducer.reducer;
reducer[alertReducer.name] = alertReducer.reducer;
reducer[appReducer.name] = appReducer.reducer;
reducer[authReducer.name] = authReducer.reducer;
reducer[beaconReducer.name] = beaconReducer.reducer;
reducer[blobReducer.name] = blobReducer.reducer;
reducer[clientConfigReducer.name] = clientConfigReducer.reducer;
reducer[contactReducer.name] = contactReducer.reducer;
reducer[crewFilterReducer.name] = crewFilterReducer.reducer;
reducer[crewFormReducer.name] = crewFormReducer.reducer;
reducer[crewMemberReducer.name] = crewMemberReducer.reducer;
reducer[crewNoteReducer.name] = crewNoteReducer.reducer;
reducer[crewResourceReducer.name] = crewResourceReducer.reducer;
reducer[crewReducer.name] = crewReducer.reducer;
reducer[crewStatusReducer.name] = crewStatusReducer.reducer;
reducer[decisionReducer.name] = decisionReducer.reducer;
reducer[docTypeReducer.name] = docTypeReducer.reducer;
reducer[entityReducer.name] = entityReducer.reducer;
reducer[eventReducer.name] = eventReducer.reducer;
reducer[geoFencingReducer.name] = geoFencingReducer.reducer;
reducer[glossaryReducer.name] = glossaryReducer.reducer;
reducer[jobAccessRequestsReducer.name] = jobAccessRequestsReducer.reducer;
reducer[jobAssistanceReducer.name] = jobAssistanceReducer.reducer;
reducer[jobFilterReducer.name] = jobFilterReducer.reducer;
reducer[jobFormReducer.name] = jobFormReducer.reducer;
reducer[jobImageReducer.name] = jobImageReducer.reducer;
reducer[jobNoteReducer.name] = jobNoteReducer.reducer;
reducer[jobProcedureReducer.name] = jobProcedureReducer.reducer;
reducer[jobRelatedDocReducer.name] = jobRelatedDocReducer.reducer;
reducer[jobRelationReducer.name] = jobRelationReducer.reducer;
reducer[jobReducer.name] = jobReducer.reducer;
reducer[jobStatusReducer.name] = jobStatusReducer.reducer;
reducer[jobTagReducer.name] = jobTagReducer.reducer;
reducer[jobUpdateReducer.name] = jobUpdateReducer.reducer;
reducer[levelReducer.name] = levelReducer.reducer;
reducer[listReducer.name] = listReducer.reducer;
reducer[listNotesReducer.name] = listNotesReducer.reducer;
reducer[locationReducer.name] = locationReducer.reducer;
reducer[logReducer.name] = logReducer.reducer;
reducer[mapOverlayReducer.name] = mapOverlayReducer.reducer;
reducer[mapPathReducer.name] = mapPathReducer.reducer;
reducer[mapViewReducer.name] = mapViewReducer.reducer;
reducer[mapZoneReducer.name] = mapZoneReducer.reducer;
reducer[notificationRuleReducer.name] = notificationRuleReducer.reducer;
reducer[outsideAgencyReducer.name] = outsideAgencyReducer.reducer;
reducer[participantReducer.name] = participantReducer.reducer;
reducer[pendingUpdateReducer.name] = pendingUpdateReducer.reducer;
reducer[priorityReducer.name] = priorityReducer.reducer;
reducer[problemReducer.name] = problemReducer.reducer;
reducer[procedureReducer.name] = procedureReducer.reducer;
reducer[requiredCommentsReducer.name] = requiredCommentsReducer.reducer;
reducer[resultReducer.name] = resultReducer.reducer;
reducer[taskListReducer.name] = taskListReducer.reducer;
reducer[taskListEntryReducer.name] = taskListEntryReducer.reducer;
reducer[taskListNoteReducer.name] = taskListNoteReducer.reducer;
reducer[typeReducer.name] = typeReducer.reducer;
reducer[weatherReducer.name] = weatherReducer.reducer;
reducer[refDocReducer.name] = refDocReducer.reducer;
reducer[scheduledJobReducer.name] = scheduledJobReducer.reducer;
reducer[settingReducer.name] = settingReducer.reducer;
reducer[siteReducer.name] = siteReducer.reducer;
reducer[sitrepReducer.name] = sitrepReducer.reducer;
reducer[sitrepDefReducer.name] = sitrepDefReducer.reducer;
reducer[epcrReducer.name] = epcrReducer.reducer;
reducer[epcrHistoryReducer.name] = epcrHistoryReducer.reducer;
reducer[epcrMedicationsReducer.name] = epcrMedicationsReducer.reducer;
reducer[epcrAllergiesReducer.name] = epcrAllergiesReducer.reducer;
reducer[epcrComplaintReducer.name] = epcrComplaintReducer.reducer;
reducer[epcrDispositionReducer.name] = epcrDispositionReducer.reducer;
reducer[epcrNotesReducer.name] = epcrNotesReducer.reducer;
reducer[epcrVitalReducer.name] = epcrVitalReducer.reducer;
reducer[epcrTreatmentMedicationReducer.name] = epcrTreatmentMedicationReducer.reducer;
reducer[epcrProcedureReducer.name] = epcrProcedureReducer.reducer;
reducer[messageHistoryReducer.name] = messageHistoryReducer.reducer;
reducer[stdReplyReducer.name] = stdReplyReducer.reducer;
reducer[publicFormReducer.name] = publicFormReducer.reducer;
reducer[publicGroupReducer.name] = publicGroupReducer.reducer;
reducer[userReducer.name] = userReducer.reducer;
reducer[requestableJobsReducer.name] = requestableJobsReducer.reducer;

const PERSIST_VERSION = 2;
const PERSIST_KEY = 'chronicler'

const sessionPersistConfig = {
  key: `${PERSIST_KEY}-auth`,
  storage: sessionStorage,
  version: PERSIST_VERSION,
  whitelist: ['auth'], // only this slice
  migrate: async (state, version) => {
    if (version < PERSIST_VERSION) {
        return undefined; //invalidated
    }
    return state;
  }
};

const indexedDbPersistConfig = {
  key: PERSIST_KEY,
  storage: indexedDBStorage(PERSIST_KEY),
  version: PERSIST_VERSION,
  blacklist: ['auth', 'app'],
  migrate: async (state, version) => {
    if (version < PERSIST_VERSION) return undefined;
    return state;
  },
};

const { auth: authReducerFn, ...restReducers } = reducer;

const rootReducer = combineReducers({
  auth: persistReducer(sessionPersistConfig, authReducerFn),
  ...restReducers,
});
const persistedReducer = persistReducer(indexedDbPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
        serializableCheck: {
            ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            ignoredPaths: ['_persist']
        }
    })
  }
});

export const persistor = persistStore(store);